<div class="grid" [class.no-x-padding]="!xPadding">
  @for (product of products(); track $index) {
    @if (product.netPrice) {
      <app-otc-product [item]="product" />
    }
  }
</div>